// extracted by mini-css-extract-plugin
export default {"root":"P6bUmwIi"};